<div
    class="wrapper"
    [class.with-background]="backgroundColor"
    [style.backgroundColor]="backgroundColor"
    [style.color]="color"
    [style.borderColor]="color"
>
    <div class="chip-label"><ng-content></ng-content></div>
</div>
